import { useIsMobile } from 'sierra-client/state/browser/selectors'

export const useIsMobileHelper = (): boolean => useIsMobile()
